var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.9,
    y: 0.9,
    width: 23.4852,
    height: 23.4852,
    rx: 1.1,
    transform: "matrix(-1 0 0 1 23.4854 19.7134)",
    fill: "white",
    stroke: "#293035",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8126 27.4197C36.1499 23.4077 36.2681 17.204 33.0891 12.9886C30.561 9.6362 25.6985 7.02676 20.5389 8.5079L21.8228 5.26983C22.1078 4.57553 21.7725 3.78772 21.0907 3.49723C20.4088 3.20679 19.6287 3.53534 19.349 4.24191L16.9669 10.2218C16.821 10.578 16.8421 10.9752 16.9962 11.3081C17.1331 11.6039 17.3845 11.8601 17.7108 11.9897L23.1783 15.3481C23.8602 15.6384 24.6342 15.2968 24.9195 14.6026C25.3296 13.6045 24.2162 12.8483 24.1883 12.8295L21.0859 10.8827C25.4847 10.1766 29.1666 12.2487 30.9739 14.6512C33.4092 17.8672 33.3185 22.5963 30.7818 25.6518C30.3019 26.2135 30.3657 27.0876 30.9295 27.5705C31.4811 28.0589 32.3384 27.9935 32.8126 27.4197Z",
    fill: "#604099"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate-left.add6824e8090358c7b9b3536e392caf5.svg";
export { ForwardRef as ReactComponent };